/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import NotificationBadge, { Effect } from 'react-notification-badge';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';

import Applications from './Applications';
import * as actions from '../actions';
import * as c from '../constant';

function ApplicationContainer({
  match,
  pathName,
  permissions,
  transactionListCount,
  getTransactionCount,
}) {

  const newApplicationCounts = _.get(transactionListCount, 'new_applications');

  const updateListCountData = useCallback(() => {
    getTransactionCount();
  }, [transactionListCount]);

  useEffect(() => {
    updateListCountData();
  }, []);

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item position-relative">
                <Link
                  to="/ebpls/applications/new"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('ebpls/applications/new') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  <div
                    className="position-absolute fixed-top fixed-right"
                    style={{ zIndex: '1' }}
                  >
                    <NotificationBadge
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                      count={_.get(newApplicationCounts, 'NEW', 0)}
                      effect={Effect.SCALE}
                    />
                  </div>
                  New
                </Link>
              </li>
              {Acl(permissions, ['EBPLS BPLO - RENEWAL']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/ebpls/applications/renewal"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('ebpls/applications/renewal') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'RENEWAL', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Renewal
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/new`} />}
          />
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/renewal`} />}
          />
          <Route
            path={`${match.path}/:transaction_type`}
            component={Applications}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

ApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  transactionListCount: PropTypes.instanceOf(Object).isRequired,
  getTransactionCount: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),

  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainer);